import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-blue-100 to-white px-4 text-center">
      <h1 className="text-8xl font-extrabold text-blue-600 drop-shadow-lg animate-bounce">
        404
      </h1>

      <h2 className="text-3xl font-semibold text-gray-800 mt-4">
        Page Not Found
      </h2>

      <p className="text-gray-600 mt-2 max-w-md">
        Oops! The page you’re looking for doesn’t exist.....
      </p>

      <Link
        to="/"
        className="mt-6 bg-gradient-to-r from-blue-500 to-blue-700 text-white px-6 py-3 rounded-lg shadow-md hover:scale-105 hover:from-blue-600 hover:to-blue-800 transition-all duration-300 ease-in-out"
      >
        Go Back Home
      </Link>
    </div>
  );
};

export default NotFound;
